import { render, staticRenderFns } from "./UserAdminView.vue?vue&type=template&id=fe1c1c1c&scoped=true&"
import script from "./UserAdminView.vue?vue&type=script&lang=js&"
export * from "./UserAdminView.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminView.vue?vue&type=style&index=0&id=fe1c1c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1c1c1c",
  null
  
)

export default component.exports